<template>
  <div
    class="newsCont container-fluid"
    v-title
    data-title="广东多对多物联集团股份有限公司"
  >
    <div class="container">
      <div class="tit">
        <div class="title">{{ newsData.title }}</div>
        <div class="date">{{ newsData.create_time }}</div>
      </div>
      <div class="article" v-html="newsData.content"></div>
    </div>
    <!--    <div class="pageBox w1000">-->
    <!--      <div class="prev" @click="prevNews(newsData.prev)">{{ newsData.prev?'上一篇':'没有了' }}</div>-->
    <!--      <div class="home"><router-link to="/">首页</router-link></div>-->
    <!--      <div class="next" @click="nextNews(newsData.next)">{{ newsData.next?'下一篇':'没有了' }}</div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import topNav from "../../components/topNav";
import bottom from "../../components/bottom";

export default {
  name: "newsContent",
  components: {
    topNav,
    bottom,
  },
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "多对多物联集团、银发经济、人口老龄化、心脑血管、慢性疾病、血压高、血糖、体脂管理、中医馆、养生馆、健康管理师、科学工作站、公益行动、老年产品目录、健康机构、客户管理、拓客、医保社保、养生保健、远程管理",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商，是华为战略合作伙伴，华为健康数据与多对多实现互联互通。多对多健康管理 SaaS 系统和健康管理拓客赢利AI解决方案，为用户建立健康档案，提供健康 AI 管理。业务涵盖医院、养老机构、社区中心、康养中心、养老院、中医馆、养生馆等。针对人口老龄化现状和银发经济趋势，多对多加入了科学健康指导工作站，百城千镇家庭防大病数智服务健康公益行动办公室。开放专业健康管理师进驻，实现合作加盟共赢。",
      },
    ],
  },
  data() {
    return {
      newsData: {},
    };
  },
  mounted() {
    let id = this.$route.params.id;
    //console.log(this.$route.params.id);
    this.getNewsCont(id);
  },
  watch: {
    $route(to, from) {
      //路由参数发生改变，触发事件
      let id = this.$route.params.id;
      this.getNewsCont(id);
    },
  },
  methods: {
    getNewsCont(id) {
      this.sendHttp({
        url: this.baseUrl + "/article/getarticle",
        method: "post",
        data: { id },
      }).then((res) => {
        if (res.code == "0") {
          //console.log(res.data);
          this.newsData = res.data;
        }
      });
    },
    prevNews(id) {
      if (id) {
        this.$router.push({
          path: "/news/" + id + ".html",
          params: { id },
        });
      }
    },
    nextNews(id) {
      if (id) {
        this.$router.push({
          path: "/news/" + id + ".html",
          params: { id },
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.newsCont {
  padding-bottom: 50px;
  box-shadow: 0 10px 10px -3px #efefef;
  .tit {
    margin: 100px 0;
    position: relative;
    @media (max-width: 992px) {
      margin: 60px 0;
    }

    .title {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
    }

    .date {
      text-align: center;
      margin-top: 20px;
    }
  }
}

.pageBox {
  display: flex;
  justify-content: space-between;
  line-height: 60px;
  margin: 100px auto;
  box-shadow: #e6e6e6 0px 0px 10px;
  div {
    padding: 0 40px;
    cursor: pointer;
  }
  .next {
    color: #00cfc8;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/newsContent.vue